import "@/App.css";
import "@/cinematic.css";
import "@/cinematic-sections.css";
import "@/site.css";
import "@/dashboard.css";
import "@/dashboard-parity.css";
import "@/logo-hero-authority.css";
import "@/legendary-motion.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { LoneStarAuthProvider } from "@/context/LoneStarAuthContext";

import Home from "@/pages/CinematicHome";
import StartABond from "@/pages/StartABond";
import ThankYou from "@/pages/ThankYou";
import HowBailWorks from "@/pages/HowBailWorks";
import MontgomeryCountyJail from "@/pages/MontgomeryCountyJail";
import ServiceAreasIndex from "@/pages/ServiceAreasIndex";
import ServiceAreaCity from "@/pages/ServiceAreaCity";
import Financing from "@/pages/Financing";
import FAQ from "@/pages/FAQ";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Emergency from "@/pages/Emergency";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import DataCollectionPolicy from "@/pages/DataCollectionPolicy";

import Login from "@/pages/dashboard/Login";
import DashboardApp from "@/pages/dashboard/DashboardApp";

import LoneStarLogin from "@/pages/lonestar/LoneStarLogin";
import SSOCallback from "@/pages/lonestar/SSOCallback";
import LoneStarApp from "@/pages/lonestar/LoneStarApp";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <LanguageProvider>
            <AuthProvider>
              <Routes>
                {/* Public marketing site */}
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<HowBailWorks />} />
                <Route path="/start-a-bond" element={<StartABond />} />
                <Route path="/thank-you" element={<ThankYou />} />
                <Route path="/how-bail-works" element={<HowBailWorks />} />
                <Route path="/montgomery-county-jail" element={<MontgomeryCountyJail />} />
                <Route path="/areas" element={<ServiceAreasIndex />} />
                <Route path="/areas/:slug" element={<ServiceAreaCity />} />
                <Route path="/financing" element={<Financing />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/emergency" element={<Emergency />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/data-collection-policy" element={<DataCollectionPolicy />} />

                {/* Staff Operations Dashboard */}
                <Route path="/dashboard/login" element={<Login />} />
                <Route path="/dashboard/*" element={<DashboardApp />} />

                {/* Lone Star Cross-Brand Bridge (separate app/session, same backend) */}
                <Route path="/lonestar/login" element={<LoneStarAuthProvider><LoneStarLogin /></LoneStarAuthProvider>} />
                <Route path="/lonestar/sso/callback" element={<LoneStarAuthProvider><SSOCallback /></LoneStarAuthProvider>} />
                <Route path="/lonestar/*" element={<LoneStarAuthProvider><LoneStarApp /></LoneStarAuthProvider>} />

                <Route path="*" element={<Home />} />
              </Routes>
            </AuthProvider>
          </LanguageProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
